<app-display-counts-widget
  [widgetPanelCounts]="widgetPanelCounts"
  [widgetPanel]="{ style: {} }"
  [title]="widgetPanelCounts.title"
></app-display-counts-widget>
